/** Keep programmatic navigation consistent with the visitor's motion preference. */
export function pageScrollBehavior(): ScrollBehavior {
  return typeof window !== "undefined" && typeof window.matchMedia === "function"
    && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
}
